var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenThunder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 54.5,
    r: 54.5,
    fill: "url(#paint0_linear_613_1838)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.749 25.5108H44.9532C44.4736 25.5108 44.0489 25.8209 43.9027 26.2779L32.5566 61.7382C32.1769 62.9252 33.0619 64.1385 34.3075 64.1385H50.4275C51.1953 64.1385 51.7282 64.9037 51.4622 65.6244L42.5682 89.7266C42.1433 90.8783 43.6328 91.7594 44.4364 90.8318L76.0788 54.3068C77.1107 53.1157 76.2651 51.2626 74.6897 51.2626H60.6397C59.8198 51.2626 59.2865 50.3992 59.6532 49.6654L70.3933 28.1728C71.0044 26.9498 70.1156 25.5108 68.749 25.5108Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_613_1838",
    x1: 54.5,
    y1: 0,
    x2: 54.5,
    y2: 109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00754F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenThunder);
export default __webpack_public_path__ + "static/media/green-thunder.7d3295afa4af40045f572c301f8f0a8c.svg";
export { ForwardRef as ReactComponent };